import styles from "./styles.module.scss";
import cn from "classnames";

export const OurSectors = ({ title, description, sectors, className }) => {
  return (
    <section className={cn(styles.OurSectors, className)}>
      <div className={styles.glow} />
      <h2 className={styles.heading} data-sourceflow-prop="title">
        {title}
      </h2>

      <div className={styles.introBox}>
        <div
          className={styles.introText}
          data-sourceflow-prop="description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>

      <div className={styles.grid}>
        {sectors?.map(({ name, image }, idx) => (
          <div key={idx} className={styles.card} style={{ backgroundImage: `url(${image?.url})` }}>
            <div className={styles.cardText} data-sourceflow-prop={`sectors[${idx}].name`}>
              {name}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurSectors;
